const initialState = {
  pathname: undefined,
  experience: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOCATION_CHANGE': {
      const pathname = action.payload.location.pathname;
      const search = action.payload.location.search;
      const experience = action.payload.location.experience;
      return {
        ...state,
        pathname,
        search,
        experience,
      };
    }
    default:
      return state;
  }
}
